import { useRef } from 'react';
import useBreakpointImage, { type BreakpointImageProps } from '~/hooks/useBreakpointImage';
import styled from '@emotion/styled';

const Image = styled.img<{ blur?: boolean }>`
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: 250ms all linear;

	${({ blur }) => blur && 'filter: blur(1rem); transform: scale(1.05);'}
`;

export default function MicrositeBreakpointImg({ priority, url }: Omit<BreakpointImageProps, 'ref'>) {
	const ref = useRef<HTMLImageElement>(null);

	const { srcSet, placeholder } = useBreakpointImage({ ref, priority, url });

	return <Image src={placeholder} ref={ref} srcSet={srcSet} blur={!srcSet} />;
}
